import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Page} from '../../shared/model/core/page.model';
import {UrlBuilder} from '../../shared/utils/url.builder';
import {Pageable} from '../../shared/model/core/pageable.model';
import {BackendServiceUtils} from '../../shared/utils/backend-service.utils';
import {
    AccountingAccountModel,
    EditBankAccount
} from '../../modules/accounting/account/api/entity/accountingAccount.model';

@Injectable()
export class BankAccountService {
    private static readonly ROOT_PATH  = '/v1/accounting/accounts';

    constructor(private httpClient: HttpClient, private backendServiceUtils: BackendServiceUtils) {}

    find(pageable: Pageable): Promise<Page<AccountingAccountModel>> {
        const url: string = this.buildUrl()
            .withPagination(pageable)
            .build();
        return this.httpClient.get<Page<AccountingAccountModel>>(url).toPromise();
    }

    findAll(): Promise<AccountingAccountModel[]> {
        return this.backendServiceUtils.findAll(this.buildUrl());
    }

    findById(id: number): Promise<AccountingAccountModel> {
        return this.httpClient.get<AccountingAccountModel>(environment.webserviceUrl + BankAccountService.ROOT_PATH + '/' + id).toPromise();
    }

    create(editBankAccount: EditBankAccount): Promise<AccountingAccountModel> {
        return this.httpClient.post<AccountingAccountModel>
        (environment.webserviceUrl + BankAccountService.ROOT_PATH, editBankAccount).toPromise();
    }

    update(bankAccountId: number, editBankAccount: EditBankAccount): Promise<AccountingAccountModel> {
        return this.httpClient.put<AccountingAccountModel>
        (environment.webserviceUrl + BankAccountService.ROOT_PATH + '/' + bankAccountId, editBankAccount).toPromise();
    }

    buildUrl() {
        return new UrlBuilder(environment.webserviceUrl + BankAccountService.ROOT_PATH);
    }
}

